module.exports = __webpack_public_path__ + "static/media/sru_logo.781b38ec.svg";